let WEBFLOW_SCRIPT_BASE_URL:
  | 'https://cdn.flowphantom.com'
  | 'https://staging.flowphantom.com'
  | 'https://flowphantom-andrew-bass-flowphantom.vercel.app'
  | 'http://localhost:3000';
let url: undefined | string;

if (typeof window !== 'undefined') {
  url = window.location.href;
}

if (!url) {
  throw new Error('url is undefined');
}

if (url.indexOf('https://dev.elevatedcollections.com') > -1) {
  WEBFLOW_SCRIPT_BASE_URL = 'http://localhost:3000';
} else if (url.indexOf('https://branch.elevatedcollections.com') > -1) {
  WEBFLOW_SCRIPT_BASE_URL =
    'https://flowphantom-andrew-bass-flowphantom.vercel.app';
} else if (url?.indexOf('https://staging.elevatedcollections.com') > -1) {
  WEBFLOW_SCRIPT_BASE_URL = 'https://staging.flowphantom.com';
} else {
  WEBFLOW_SCRIPT_BASE_URL = 'https://cdn.flowphantom.com';
}

export { WEBFLOW_SCRIPT_BASE_URL };
